module.exports = __webpack_public_path__ + "img/type2_bg2.97d2ca5f.png";